import { useEffect } from 'react'
import styled from '@emotion/styled'
import Results from './Results'
import { connect } from 'react-redux'
import { setApi, getDesigns } from '../../../../data/actions'

const Container = styled.div`
  text-align: center;
`

const Main = ({ memberId }) => {
  // const testUrl =
  //   'https://cdn3.iconfinder.com/data/icons/logos-brands-3/24/logo_brand_brands_logos_linux-512.png'
  // const testData =
  //   process.env.NODE_ENV !== 'production'
  //     ? [
  //         { id: Math.floor(Math.random() * Math.floor(100)), url: testUrl },
  //         { id: Math.floor(Math.random() * Math.floor(100)), url: testUrl },
  //         { id: Math.floor(Math.random() * Math.floor(100)), url: testUrl },
  //       ]
  //     : []

  useEffect(() => {
    setApi()
    getDesigns(memberId)
  }, [memberId])

  return (
    <Container>
      <Results />
    </Container>
  )
}

const mapStateToProps = (state) => ({
  memberId: state.memberId,
})

export default connect(mapStateToProps)(Main)
